import { GeneralArea, GeneralSignInMethod, useRepositoryMutation } from '@mews-commander/data-access';
import { LocalizedText, lt, showErrorAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { TwoFactorForm, TwoFactorFormValues } from '../../../../components/TwoFactorForm';
import {
    checkForHardDeviceApproval,
    DEVICE_AUTH_REQUIRED,
    getDeviceFingerprintPayload,
    INITIAL_SIGN_IN_PARAMS,
    initializeUserSession,
} from '../../../../ducks/actions';

const actions = {
    primary: (
        <Button type="submit" size="medium" variant="primary" wide>
            <LocalizedText textKey={TextKey.Login} />
        </Button>
    ),
};

export const TwoFactorAuthenticationForm = () => {
    const dispatch = useCommanderThunkDispatch();
    const { mutateAsync: signIn } = useRepositoryMutation('generalUsers', 'signIn', {
        meta: { disableDefaultErrorHandler: true },
    });

    const onSubmit = async ({ pin }: TwoFactorFormValues) =>
        signIn({
            ...INITIAL_SIGN_IN_PARAMS,
            device: getDeviceFingerprintPayload(),
            pin,
            method: GeneralSignInMethod.SignInToken,
            application: GeneralArea.Commander,
        })
            .then(async (data) => dispatch(checkForHardDeviceApproval(data)))
            .then(async (data) => dispatch(initializeUserSession(data)))
            .catch((e) => {
                if (e.message !== DEVICE_AUTH_REQUIRED) {
                    showErrorAlert({ description: lt('AuthenticationFailedErrorMessage') });
                }
            });

    return <TwoFactorForm onSubmit={onSubmit} id="pin-form-logins" actions={actions} />;
};
